import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import { publicationsHeader, publications } from "../../portfolio.js";
import "./ResearchPage.css";

class ResearchPage extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="research-page-main">
        <Header theme={theme} />
        <div className="research-page-header">
          <Fade bottom duration={2000} distance="40px">
            <h1 className="research-page-title" style={{ color: theme.text }}>
              {publicationsHeader.title}
            </h1>
            <p
              className="subTitle research-page-subtitle"
              style={{ color: theme.secondaryText }}
            >
              {publicationsHeader.description}
            </p>
          </Fade>
        </div>
        <div className="research-papers-grid">
          {publications.data.map((paper, i) => (
            <Fade bottom duration={1000} distance="20px" key={paper.id}>
              <a
                href={paper.url}
                target="_blank"
                rel="noopener noreferrer"
                className="research-paper-card"
                style={{ backgroundColor: theme.highlight }}
              >
                <p
                  className="research-paper-journal"
                  style={{ color: theme.secondaryText }}
                >
                  {paper.description}
                </p>
                <h2
                  className="research-paper-title"
                  style={{ color: theme.text }}
                >
                  {paper.name}
                </h2>
                {paper.keywords && (
                  <div className="research-paper-keywords">
                    {paper.keywords.slice(0, 4).map((kw, j) => (
                      <span
                        key={j}
                        className="research-paper-keyword"
                        style={{
                          color: theme.text,
                          borderColor: theme.secondaryText,
                        }}
                      >
                        {kw}
                      </span>
                    ))}
                  </div>
                )}
                <span
                  className="research-paper-read-btn"
                  style={{ color: theme.text }}
                >
                  Read paper &rarr;
                </span>
              </a>
            </Fade>
          ))}
        </div>
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default ResearchPage;
